import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.map";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import List from './List/List';
import Item from './Item/Item';
import { getPages } from './Utils/PaginationCalculator';
/** Customizable Pagination component */

var Pagination = function Pagination(_ref) {
  var PageComponent = _ref.PageComponent,
      totalPages = _ref.totalPages,
      maxPages = _ref.maxPages,
      currentPage = _ref.currentPage,
      showFirst = _ref.showFirst,
      firstLabel = _ref.firstLabel,
      firstAriaLabel = _ref.firstAriaLabel,
      showPrevious = _ref.showPrevious,
      previousLabel = _ref.previousLabel,
      previousAriaLabel = _ref.previousAriaLabel,
      showMore = _ref.showMore,
      moreLabel = _ref.moreLabel,
      moreAriaLabel = _ref.moreAriaLabel,
      showNext = _ref.showNext,
      nextLabel = _ref.nextLabel,
      nextAriaLabel = _ref.nextAriaLabel,
      showLast = _ref.showLast,
      lastLabel = _ref.lastLabel,
      lastAriaLabel = _ref.lastAriaLabel,
      getPageLabel = _ref.getPageLabel,
      getPageAriaLabel = _ref.getPageAriaLabel,
      onSelect = _ref.onSelect,
      createURL = _ref.createURL,
      pageComponentProps = _ref.pageComponentProps,
      restProps = _objectWithoutProperties(_ref, ["PageComponent", "totalPages", "maxPages", "currentPage", "showFirst", "firstLabel", "firstAriaLabel", "showPrevious", "previousLabel", "previousAriaLabel", "showMore", "moreLabel", "moreAriaLabel", "showNext", "nextLabel", "nextAriaLabel", "showLast", "lastLabel", "lastAriaLabel", "getPageLabel", "getPageAriaLabel", "onSelect", "createURL", "pageComponentProps"]);

  if (!totalPages) {
    return null;
  }

  var getItem = function getItem(label, ariaLabel, value, disabled) {
    return {
      disabled: disabled,
      selected: currentPage === value,
      label: label,
      value: value,
      ariaLabel: ariaLabel
    };
  };

  var items = [];

  if (showFirst) {
    items.push(getItem(firstLabel, firstAriaLabel, 1, currentPage === 1));
  }

  if (showPrevious) {
    items.push(getItem(previousLabel, previousAriaLabel, currentPage - 1, currentPage === 1));
  }

  var pages = getPages(currentPage, maxPages, totalPages);

  if (showMore && pages[0] > 1) {
    items.push(getItem(moreLabel, moreAriaLabel, -1, true));
  }

  items = items.concat(pages.map(function (value) {
    return getItem(getPageLabel(value), getPageAriaLabel(value), value, false);
  }));

  if (showMore && pages[pages.length - 1] < totalPages) {
    items.push(getItem(moreLabel, moreAriaLabel, -2, true));
  }

  if (showNext) {
    items.push(getItem(nextLabel, nextAriaLabel, currentPage + 1, currentPage === totalPages || totalPages === 1));
  }

  if (showLast) {
    items.push(getItem(lastLabel, lastAriaLabel, totalPages, currentPage === totalPages || totalPages === 1));
  }

  return React.createElement(List, Object.assign({
    pages: items,
    PageComponent: PageComponent,
    pageComponentProps: pageComponentProps,
    createURL: createURL,
    onSelect: onSelect
  }, restProps));
};

Pagination.defaultProps = {
  PageComponent: Item,
  pageComponentProps: {},
  showFirst: true,
  showPrevious: true,
  showNext: true,
  showLast: true,
  showMore: true,
  maxPages: 5,
  previousLabel: '‹',
  nextLabel: '›',
  firstLabel: '«',
  lastLabel: '»',
  moreLabel: '...',
  getPageLabel: function getPageLabel(currentPage) {
    return currentPage.toString();
  },
  previousAriaLabel: 'Previous page',
  nextAriaLabel: 'Next page',
  firstAriaLabel: 'First page',
  lastAriaLabel: 'Last page',
  moreAriaLabel: 'More pages',
  getPageAriaLabel: function getPageAriaLabel(currentPage) {
    return "Page ".concat(currentPage);
  },
  target: 'self',
  color: 'black',
  backgroundColor: 'white',
  selectedColor: 'white',
  selectedBackgroundColor: 'red',
  disabledColor: 'grey_medium',
  disabledBackgroundColor: 'white',
  colorOnHover: 'white',
  backgroundColorOnHover: 'teal'
};
export default Pagination;